const CREATE_FOLDER_API = '/usermedialibrary/upsert_folder';
const DELETE_FOLDER_API = '/usermedialibrary/remove_folder';
const UNDO_DELETE_FOLDER_API = '/usermedialibrary/undo_remove_folder';
const ADD_IMAGES_TO_FOLDER_API = '/usermedialibrary/add_images';

interface CreateFolderResponse {
  status: 'ok' | 'fail';
  message: string;
  folder: {
    id: number;
    name: string;
  };
}
interface CreateFolderRequest {
  name: string;
  id?: string;
}

interface FolderRequest {
  value?: string;
  label: string;
  medias?: string;
}
export interface AddImageToFolderRequest {
  folder: FolderRequest;
  from?: FolderRequest;
}

interface DeleteFolderResponse {
  status: 'ok' | 'fail';
  message: string;
}

/**
 * Update/Insert a new folder
 * @param CreateFolderRequest
 * @returns CreateFolderResponse
 */
export const upsertFolder = async ({ ...request }: CreateFolderRequest) => {
  const response = await fetch(CREATE_FOLDER_API, {
    method: 'post',
    body: JSON.stringify(request),
  });
  const json = (await response.json()) as CreateFolderResponse;
  if (!json || json.status !== 'ok') throw new Error(json?.message ?? 'Unknown error');
  return json;
};

/**
 * Update images added to a folder
 * @param AddImageToFolderRequest
 * @returns CreateFolderResponse
 */
export const addImageToFolder = async ({ ...request }: AddImageToFolderRequest) => {
  const response = await fetch(ADD_IMAGES_TO_FOLDER_API, {
    method: 'post',
    body: JSON.stringify(request),
  });
  const json = (await response.json()) as CreateFolderResponse;
  if (!json || json.status !== 'ok') throw new Error(json?.message ?? 'Unknown error');
  return json;
};

/**
 * Delete a folder
 * @param id Folder id
 * @returns DeleteFolderResponse
 */
export const deleteFolder = async (id: string) => {
  const response = await fetch(DELETE_FOLDER_API, {
    method: 'post',
    body: JSON.stringify({ id }),
  });
  const json = (await response.json()) as DeleteFolderResponse;
  if (!json || json.status !== 'ok') throw new Error(json?.message ?? 'Unknown error');
  return json;
};

/**
 * Undo folder deletion
 * @param id Folder id
 * @returns DeleteFolderResponse
 */
export const undoDeleteFolder = async (id: string) => {
  const response = await fetch(UNDO_DELETE_FOLDER_API, {
    method: 'post',
    body: JSON.stringify({ id }),
  });
  const json = (await response.json()) as DeleteFolderResponse;
  if (!json || json.status !== 'ok') throw new Error(json?.message ?? 'Unknown error');
  return json;
};
